import {
  RemoveBookedResourceThunk,
  resourceManagementSaveResource,
  resourceManagementUpdateResource,
  ResourceManagementFetchSlotsThunk,
  resourceManagementFetchBuildingsThunk,
  resourceManagementFetchResourcesThunk,
  propertyManagementFetchLocationByIdThunk,
  resourceManagementFetchValidResourceByIdThunk,
} from './resourceManagementActions';
import { useAppAction, useAppSelector } from '../hooks';
import { ResourceManagementState } from './resourceManagementTypes';
import { ROOM_MANAGEMENT_NAMESPACE } from './resourceManagementReducer';

export function useResourceManagementSelector<
  T extends (state: ResourceManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) => selector(state[ROOM_MANAGEMENT_NAMESPACE]));
}

export const useResourceManagementSlots = () =>
  useResourceManagementSelector((state) => {
    return state.resourceSlots;
  });

export const useRoomManagementRooms = () =>
  useResourceManagementSelector((state) => {
    return state.resources;
  });

export const useResourceManagementBuildings = () =>
  useResourceManagementSelector((state) => {
    return state.buildings;
  });

export const useGetLocation = () =>
  useResourceManagementSelector((state) => {
    return state.location;
  });

export const useValidResource = () =>
  useResourceManagementSelector((state) => {
    return state.resource;
  });

export const useCancelBookResource = () =>
  useAppAction(RemoveBookedResourceThunk);

export const useSaveResourceAlloc = () =>
  useAppAction(resourceManagementSaveResource);

export const useFetchResourceAlloc = () =>
  useAppAction(ResourceManagementFetchSlotsThunk);

export const useFetchRoomManagementRooms = () =>
  useAppAction(resourceManagementFetchResourcesThunk);

export const useFetchResourceManagementBuildings = () =>
  useAppAction(resourceManagementFetchBuildingsThunk);

export const usePropertyManagementFetchLocationById = () =>
  useAppAction(propertyManagementFetchLocationByIdThunk);

export const useUpdateResourceAlloc = () =>
  useAppAction(resourceManagementUpdateResource);

export const useGetValidResourceById = () =>
  useAppAction(resourceManagementFetchValidResourceByIdThunk);
